import React from "react";
import Chevron from "./chevron";

const ChevronIcon = ({ direction = "right", size = 24, color, ...props }) => {
  const rotations = {
    up: "270deg",
    right: "0deg",
    down: "90deg",
    left: "180deg"
  };

  return (
    <div
      style={{
        transform: `rotate(${rotations[direction]})`,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 0
      }}
    >
      <Chevron fill={color} width={size} height={size} {...props} />
    </div>
  );
};

export default ChevronIcon;
